import { render, staticRenderFns } from "./FilterSelectStarRating.vue?vue&type=template&id=4859270f&scoped=true&"
import script from "./FilterSelectStarRating.vue?vue&type=script&lang=js&"
export * from "./FilterSelectStarRating.vue?vue&type=script&lang=js&"
import style0 from "./FilterSelectStarRating.vue?vue&type=style&index=0&id=4859270f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4859270f",
  null
  
)

component.options.__file = "FilterSelectStarRating.vue"
export default component.exports